import { Component, inject } from '@angular/core';
import { ModelTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ModelTypeCreateDto,
  ModelTypeDto,
  ModelTypeExcelDownloadDto,
  ModelTypeUpdateDto,
} from '../proxy/controlling/dtos/model-type';
import { MODELTYPE_CONFIG, MODELTYPE_FIELDS } from './model-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-model-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ModelTypeService, ConfirmationService],
  templateUrl: './model-type.html',
  styleUrl: './model-type.scss',
})
export class ModelType extends BaseCrudComponent<
  ModelTypeDto,
  ModelTypeCreateDto,
  ModelTypeUpdateDto,
  ModelTypeExcelDownloadDto
> {
  service = inject(ModelTypeService);
  config = MODELTYPE_CONFIG;
  fields = MODELTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ModelTypeDto): ModelTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ModelType';
  }
}
